import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import is from 'is_js';
import classnames from 'classnames';
import { testClass, TextArea, Tooltip, Icon, ConfirmDialog } from 'omni-common-ui';
import { PersonalisedHomework } from 'data/OnlineHomework/Personalised';
import HomeworkTypeSelect from 'components/HomeworkTypeSelect';

class HomeworkContentItemForm extends PureComponent {
  constructor() {
    super();
    this.state = {
      isConfirmDeleteDialogOpen: false,
    };
    this._getConsumedContentTypes = this._getConsumedContentTypes.bind(this);
    this._onHomeworkTypeSelected = this._onHomeworkTypeSelected.bind(this);
    this._onTextareaValueChanged = this._onTextareaValueChanged.bind(this);
    this._onDeleteHomeworkContentClicked = this._onDeleteHomeworkContentClicked.bind(this);
    this._onCloseDeleteDialog = this._onCloseDeleteDialog.bind(this);
    this._onConfirmDeleteHomeworkContentClicked =
        this._onConfirmDeleteHomeworkContentClicked.bind(this);
  }

  _getCurrentModel() {
    return this.props.model;
  }

  _getConsumedContentTypes() {
    return this._getCurrentModel().contents.map((item) => item.homeworkTypeId);
  }

  _onHomeworkTypeSelected(index, id) {
    const { homeworkContentTypes } = this.props;
    const { defaultContent } = homeworkContentTypes.get(id);
    const shouldSetContent = is.string(defaultContent);
    const newModel =
        this._getCurrentModel().update('contents', (contents) =>
          contents.update(index, (item) => {
            const _item = shouldSetContent ?
                item.set('content', defaultContent) :
                item;
            return _item.set('homeworkTypeId', id);
          }));
    this.props.onModelChange(newModel);
  }

  _onTextareaValueChanged(ev) {
    const { contentItemIndex: index } = this.props;
    const commentText = ev.target.value;
    const newModel =
        this._getCurrentModel().update('contents', (contents) =>
          contents.update(index, (item) =>
            item.set('content', commentText)));
    this.props.onModelChange(newModel);
  }

  _onDeleteHomeworkContentClicked() {
    this.setState({ isConfirmDeleteDialogOpen: true });
  }

  _onCloseDeleteDialog() {
    this.setState({ isConfirmDeleteDialogOpen: false });
  }

  _onConfirmDeleteHomeworkContentClicked() {
    const { contentItemIndex: index } = this.props;
    const newModel = this._getCurrentModel().update('contents', (contents) =>
        contents.delete(index));
    this.props.onModelChange(newModel);
    this._onCloseDeleteDialog();
  }

  _renderCharacterLimitReadout(index, maxCharacters) {
    const text = this._getCurrentModel().contents.get(index).content;
    let textLength = 0;
    if (is.string(text)) {
      textLength = text.length;
    }
    return <aside className={styles.HomeworkContentItemForm_charactersUsed}>
      {textLength}/{maxCharacters} characters
    </aside>;
  }

  _renderConfirmDeleteDialog() {
    return <ConfirmDialog isOpen={this.state.isConfirmDeleteDialogOpen}
        primaryButtonContent="Delete"
        secondaryButtonContent="Cancel"
        content="Are you sure you want to delete this content item?"
        onPrimaryClick={this._onConfirmDeleteHomeworkContentClicked}
        onSecondaryClick={this._onCloseDeleteDialog}
        onRequestClose={this._onCloseDeleteDialog} />;
  }

  render() {
    const {
      courseTypeLevelId,
      contentItem: item,
      contentItemIndex: index,
      contentItemCount: count,
    } = this.props;
    return <div className={styles.HomeworkContentItemForm}>
      <h4>Type</h4>
      <HomeworkTypeSelect courseTypeLevelId={courseTypeLevelId}
          value={item.homeworkTypeId}
          getConsumedTypes={this._getConsumedContentTypes}
          onSelect={(typeId) => {
            this._onHomeworkTypeSelected(index, typeId);
          }} />
      <h4>Content</h4>
      <TextArea className={classnames(styles.HomeworkContentItemForm_textarea,
            testClass('personalised-homework-form-content'))}
          name="content"
          value={item.content}
          maxLength={500}
          onChange={this._onTextareaValueChanged} />
      {this._renderCharacterLimitReadout(index, 500)}
      {count > 1 ? <div className={styles.HomeworkContentItemForm_deleteButton}>
        <Tooltip text="Delete"
            placement="top"
            trigger={['hover']}>
          <a onClick={this._onDeleteHomeworkContentClicked}
              role="button"
              tabIndex={0}>
            <Icon id="trash" />
          </a>
        </Tooltip>
      </div> : null}
      {this._renderConfirmDeleteDialog()}
    </div>;
  }
}

HomeworkContentItemForm.propTypes = {
  courseTypeLevelId: PropTypes.string.isRequired,
  homeworkContentTypes: PropTypes.instanceOf(Map).isRequired,
  contentItem: PropTypes.instanceOf(Map).isRequired,
  contentItemIndex: PropTypes.number.isRequired,
  contentItemCount: PropTypes.number.isRequired,
  model: PropTypes.instanceOf(PersonalisedHomework).isRequired,
  onModelChange: PropTypes.func.isRequired,
};

export default HomeworkContentItemForm;



// WEBPACK FOOTER //
// ./containers/Group/AssignHomework/Assignments/PersonalisedHomeworkFormCard/HomeworkContentItemForm/index.jsx